import { render, staticRenderFns } from "./ThreadsNew.vue?vue&type=template&id=5e6a755a&"
import script from "./ThreadsNew.vue?vue&type=script&lang=js&"
export * from "./ThreadsNew.vue?vue&type=script&lang=js&"
import style0 from "./ThreadsNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports